<template>
  <div>
    <e-sidebar
      :title="edit ? $t('Editar item calendário') : $t('Novo item calendário')"
      :show="showSidebar"
      :fetching="fetching"
      :saving="saving"
      width="500px"
      @save="saveCalendarLocal"
      @hidden="cancel"
    >
      <template #content>
        <div>
          <FormulateForm 
            ref="form" 
            name="form"
          >
            <b-row>
              <b-col md="12">
                <FormulateInput
                  id="calendar-name"
                  v-model="formCalendar.name"
                  :label="$t('Nome')"
                  type="text"
                  class="required"
                  validation="required"
                  maxlength="200"
                />
              </b-col>
              <b-col md="12">
                <FormulateInput
                  id="calendar-type"
                  v-model="formCalendar.type"
                  :label="$t('Tipo')"
                  type="vue-select"
                  :placeholder="$t('Selecione')"
                  :options="calendarTypes"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="12">
                <FormulateInput
                  id="calendar-province"
                  v-model="formCalendar.provinces"
                  :label="$t('Estado')"
                  type="vue-select"
                  :placeholder="$t('Selecione')"
                  :options="provinceOptions"
                  :multiple="true"
                  @input="onProvinceChange"
                />
              </b-col>
              <b-col md="12">
                <FormulateInput
                  id="calendar-city"
                  v-model="formCalendar.cities"
                  :label="$t('Cidade')"
                  type="vue-select"
                  :placeholder="$t('Selecione')"
                  :options="cityOptions"
                  :multiple="true"
                />
              </b-col>
              <b-col md="12">
                <EStoreCombo
                  id="calendar-store"
                  v-model="formCalendar.stores"
                  :label="$t('Lojas')"
                  :placeholder="$t('Todas as lojas')"
                  :multiple="true"
                  :required="false"
                  :filter="getStoreFilter"
                />
              </b-col>
              <b-col md="12">
                <FormulateInput
                  id="calendar-start-date"
                  v-model="formCalendar.startDate"
                  :label="$t('Data de Início')"
                  type="datepicker"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="12">
                <FormulateInput
                  id="calendar-end-date"
                  v-model="formCalendar.endDate"
                  :label="$t('Data de Término')"
                  type="datepicker"
                  class="required"
                  validation="required"
                />
              </b-col>
              <b-col md="12">
                <FormulateInput
                  id="calendar-description"
                  v-model="formCalendar.description"
                  :label="$t('Descrição')"
                  type="textarea"
                  rows="2"
                  maxlength="400"
                />
              </b-col>
              <b-col md="12">
                <FormulateInput
                  id="calendar-purchase-factor"
                  v-model="formCalendar.purchaseFactor"
                  :label="$t('Fator de Compra')"
                  type="text-number"
                  :precision="2"
                  class="required"
                  validation="required"
                />
              </b-col>
            </b-row>
          </FormulateForm>
        </div>
      </template>
    </e-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { province } from '@/mixins'
import { BRow, BCol } from 'bootstrap-vue'
import { ESidebar, EStoreCombo } from '@/views/components'

export default {
  components: {
    BRow,
    BCol,
    ESidebar,
    EStoreCombo,
  },
    mixins: [province],
  props: {
    calendarId: {
      type: Number,
      default: null,
    },
    calendar: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showSidebar: false,
      fetching: false,
      edit: false,
      saving: false,
      localCalendarId: null,
    }
  },
  computed: {
    ...mapGetters('app', [
      'activeStoreOptions',
    ]),
    ...mapGetters('pages/settings/calendar', [
      'calendarTypes',
    ]),
    ...mapState('pages/settings/calendar/calendarMaintain', [
      'formCalendar',
      'cities',
    ]),
    provinceOptions() {
      return (this.provincesWithStores() || []).map(p => ({
        value: p.ibge,
        label: p.value,
      }))
    },
    cityOptions() {
      return this.cities.map(city => ({
        value: city.idIbge,
        label: city.name,
      }))
    },
    getStoreFilter() {
      let selectedProvinces = []
      if (Array.isArray(this.formCalendar.provinces)) {
        selectedProvinces = this.formCalendar.provinces
      } else if (this.formCalendar.provinces) {
        selectedProvinces = [this.formCalendar.provinces]
      }
      
      let selectedCities = []
      if (Array.isArray(this.formCalendar.cities)) {
        selectedCities = this.formCalendar.cities
      } else if (this.formCalendar.cities) {
        selectedCities = [this.formCalendar.cities]
      }

      // Se nenhum filtro foi selecionado, retorna função que aceita todas as lojas
      if (selectedProvinces.length === 0 && selectedCities.length === 0) {
        return () => true
      }

      console.log('Selected Provinces:', selectedProvinces)
      console.log('Selected Cities:', selectedCities)

      // Retorna função que filtra lojas por estados e/ou cidades selecionadas
      return store => {
        const storeProvinceCode = store.address?.provinceCode?.toString()
        const storeCityCode = store.address?.cityCode?.toString()

        // Se estados foram selecionados, verifica se a loja está neles
        if (selectedProvinces.length > 0) {
          const isInSelectedProvinces = selectedProvinces.some(
            p => p.toString() === storeProvinceCode
          )
          // Se tem cidades selecionadas também, verifica se está nelas
          if (selectedCities.length > 0) {
            return isInSelectedProvinces && selectedCities.some(
              c => c.toString() === storeCityCode
            )
          }
          return isInSelectedProvinces
        }

        // Se apenas cidades foram selecionadas, verifica se a loja está nelas
        if (selectedCities.length > 0) {
          return selectedCities.some(c => c.toString() === storeCityCode)
        }

        return true
      }
    },
  },
  watch: {
    calendar(val) {
      this.localCalendar = val
    },
    calendarId(val) {
      this.localCalendarId = val
    },
    async localCalendarId(val) {
      if (val) {
        try {
          this.fetching = true
          await this.fetchCalendar(val)
          if (this.formCalendar.provinces?.length) {
            this.onProvinceChange(this.formCalendar.provinces)
          }
        } catch (error) {
          this.showError({ error })
        } finally {
          this.fetching = false
        }
      } else {
        this.cleanState()
      }
    },
    'formCalendar.provinces': function() {
      // Limpa as lojas selecionadas quando os estados mudam
      // this.formCalendar.stores = []
    },
    'formCalendar.cities': function() {
      // Limpa as lojas selecionadas quando as cidades mudam
      // this.formCalendar.stores = []
    },
  },
  methods: {
    ...mapActions('pages/settings/calendar/calendarMaintain', [
      'fetchCalendar',
      'saveCalendar',
      'cleanState',
      'setCities',
    ]),
    showCreate() {
      this.edit = false
      this.showSidebar = true
    },
    async show({ id, item } = {}) {
      if (!id && !item?.id) {
        this.showCreate()
      } else {
        if (id) this.localCalendarId = id
        if (item) this.localCalendar = item
        this.edit = true
        this.showSidebar = true
      }
    },
    async saveCalendarLocal() {
      this.$refs.form.showErrors()
      if (this.$refs.form.isValid) {
        try {
          this.saving = true
          await this.saveCalendar()
          this.showSuccess({
            message: this.$t(`${this.edit ? 'Update' : 'Create'} successful`),
          })
          this.$emit('save', this.formCalendar)
          this.showSidebar = false
          this.cleanState()
          this.$formulate.reset('form')
        } catch (error) {
          this.showError({ error })
        } finally {
          this.saving = false
        }
      } else {
        this.showInvalidDataMessage()
      }
    },
    cancel() {
      this.showSidebar = false
      this.localCalendarId = null
      this.cleanState()
      this.$formulate.reset('form')
    },
    // getStoreFilter() {
    //   let selectedProvinces = []
    //   if (Array.isArray(this.formCalendar.provinces)) {
    //     selectedProvinces = this.formCalendar.provinces
    //   } else if (this.formCalendar.provinces) {
    //     selectedProvinces = [this.formCalendar.provinces]
    //   }
      
    //   let selectedCities = []
    //   if (Array.isArray(this.formCalendar.cities)) {
    //     selectedCities = this.formCalendar.cities
    //   } else if (this.formCalendar.cities) {
    //     selectedCities = [this.formCalendar.cities]
    //   }

    //   // Se nenhum filtro foi selecionado, retorna função que aceita todas as lojas
    //   if (selectedProvinces.length === 0 && selectedCities.length === 0) {
    //     return () => true
    //   }

    //   // Retorna função que filtra lojas por estados e/ou cidades selecionadas
    //   return store => {
    //     const storeProvinceCode = store.address?.provinceCode?.toString()
    //     const storeCityCode = store.address?.cityCode?.toString()

    //     // Se estados foram selecionados, verifica se a loja está neles
    //     if (selectedProvinces.length > 0) {
    //       const isInSelectedProvinces = selectedProvinces.some(
    //         p => p.toString() === storeProvinceCode
    //       )
    //       // Se tem cidades selecionadas também, verifica se está nelas
    //       if (selectedCities.length > 0) {
    //         return isInSelectedProvinces && selectedCities.some(
    //           c => c.toString() === storeCityCode
    //         )
    //       }
    //       return isInSelectedProvinces
    //     }

    //     // Se apenas cidades foram selecionadas, verifica se a loja está nelas
    //     if (selectedCities.length > 0) {
    //       return selectedCities.some(c => c.toString() === storeCityCode)
    //     }

    //     return true
    //   }
    // },
    onProvinceChange(selectedProvinces) {
      const provinceIds = Array.isArray(selectedProvinces) ? selectedProvinces : [selectedProvinces].filter(Boolean)
      const cities = []
      provinceIds.forEach(provinceId => {
        this.activeStoreOptions.filter(store => store.address?.provinceCode.toString() === provinceId.toString()).forEach(store => {
            if (store.address?.cityCode && !cities.some(city => city.idIbge.toString() === store.address.cityCode.toString())) {
                cities.push({ idIbge: store.address.cityCode, name: store.address.city })
            }
        })
        this.setCities(cities)
      })

      // Filtrar cidades selecionadas para manter apenas as dos estados selecionados
      if (Array.isArray(this.formCalendar.city)) {
        this.formCalendar.city = this.formCalendar.city.filter(cityId => cities.some(city => city.idIbge.toString() === cityId.toString()))
      }

    },
  },
}
</script>

<style></style>
